const API_BASE = 'https://vashakaur.com'; // change if needed

export async function fetchPosts() {
  const res = await fetch(`${API_BASE}/admin/?route=api_posts`, {
    headers: { 'Accept': 'application/json' },
    credentials: 'omit',
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.error || 'Failed to fetch posts');
  return json.items || [];
}

export async function fetchPostBySlug(slug) {
  const res = await fetch(`${API_BASE}/admin/?route=api_post_show&slug=${encodeURIComponent(slug)}`, {
    headers: { 'Accept': 'application/json' },
    credentials: 'omit',
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json.error || 'Failed to fetch post');
  return json.post;
}
